<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{ chop.legalEntity }}</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="apply(chop.legal_entity_id)">{{ $t('chop.apply') }}</el-button>
    </div>
    <div class="text item">
      {{ $t('chop.chop') }}: 
      <el-tooltip class="item" effect="dark" :content="chopStatus.return" placement="top">
        <el-tag :type="chopStatus.css">{{ chopStatus.text }}</el-tag>
      </el-tooltip>
    </div>
    <div class="text item">
      {{ $t('chop.license') }}: 
      <el-tooltip class="item" effect="dark" :content="licenseStatus.return" placement="top">
        <el-tag :type="licenseStatus.css">{{ licenseStatus.text }}</el-tag>
    </el-tooltip>
    </div>
    <div class="text item">
      {{ $t('chop.license-copy') }}: 
      <el-tooltip class="item" effect="dark" :content="licenseCopyStatus.return" placement="top">
        <el-tag :type="licenseCopyStatus.css">{{ licenseCopyStatus.text }}</el-tag>
      </el-tooltip>
    </div>
    <div class="text item">
      {{ $t('chop.legal-chop') }}: 
      <el-tooltip class="item" effect="dark" :content="legalChopStatus.return" placement="top">
        <el-tag :type="legalChopStatus.css">{{ legalChopStatus.text }}</el-tag>
      </el-tooltip>
    </div>
  </el-card>
</template>
<style scoped>
.text {
    font-size: 14px;
  }
.item {
    margin-bottom: 18px;
  }
.clearfix:before,
.clearfix:after {
display: table;
content: "";
}
.clearfix:after {
clear: both
}
</style>
<script>
export default {
  name: 'ChopBox',
  props: ['chop'],
  computed: {
    chopStatus: function() {
      if (!this.chop.chop || this.chop.status == 0)
        return {'css': 'success', 'text': this.$t('chop.available'), 'return': null }
      else
        return {'css': 'danger', 'text': this.$t('chop.holder') + ': ' + this.chop.chop_by, 'return': this.$t('chop.return-time') + ': ' + this.chop.chop_return }
    },
    licenseStatus: function() {
      if (!this.chop.license || this.chop.status == 0)
        return {'css': 'success', 'text': this.$t('chop.available'), 'return': null }
      else
        return {'css': 'danger', 'text': this.$t('chop.holder') + ': ' + this.chop.license_by, 'return': this.$t('chop.return-time') + ': ' + this.chop.license_return }
    },
    licenseCopyStatus: function() {
      if (!this.chop.license_copy || this.chop.status == 0)
        return {'css': 'success', 'text': this.$t('chop.available'), 'return': null }
      else
        return {'css': 'danger', 'text': this.$t('chop.holder') + ': ' + this.chop.license_copy_by, 'return': this.$t('chop.return-time') + ': ' + this.chop.license_copy_return }
    },
    legalChopStatus: function() {
      if (!this.chop.legal_chop || this.chop.status == 0)
        return {'css': 'success', 'text': this.$t('chop.available'), 'return': null }
      else
        return {'css': 'danger', 'text': this.$t('chop.holder') + ': ' + this.chop.legal_chop_by, 'return': this.$t('chop.return-time') + ': ' + this.chop.legal_chop_return }
    }
  },
  methods: {
    apply: function(legalEntityId) {
      this.$emit('apply-chop', legalEntityId)
    }
  }
}
</script>